import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import 'assets/scss/components/locationModal.css';
import SelectPlan from 'components/businesses/SelectPlan';
import { getRole } from 'constants/localStorageManager';
import { USERS } from 'constants/Users';

const PlanSelectionModal = ({
  isVisible,
  planSubscription,
  onCancel,
  plans,
  setPlanSubscription,
  setTrialLength,
  trialLength,
  onConfirm
}) => {
  if (getRole() !== USERS.ADMIN) return null;

  return (
    <Modal isOpen={isVisible} className="location-modal">
      <ModalHeader className="text-center">
        <div className="modal-title d-inline text-bold">Select Plan</div>
        <span role="none" className="close-modal" onClick={onCancel}>
          <FontAwesomeIcon icon="times" />
        </span>
      </ModalHeader>
      <ModalBody className="p-4">
        <SelectPlan
          plans={plans}
          handlePlanSelect={setPlanSubscription}
          plan_subscription={planSubscription}
          onTrialLengthSelected={e => setTrialLength(e.target.value)}
          trialLength={trialLength}
          isChangePlanVisible
          className="form-control"
        />
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-warning btn-sm py-3 pl-5 pr-5 text-white text-bold border-0 mb-2"
          type="button"
          onClick={onConfirm}
        >
          Save
        </button>
        <button className="btn" type="button" onClick={onCancel}>
          Cancel
        </button>
      </ModalFooter>
    </Modal>
  );
};

PlanSelectionModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
};

export default PlanSelectionModal;



// WEBPACK FOOTER //
// ./src/components/businessDetail/modal/planSelectionModal.js